export {default as Subtitle } from './subtitle.component';